import React, { PureComponent } from 'react';
//import PropTypes from 'prop-types';

class SlogoForm extends PureComponent {

    state = {
        base64: ''
    };

    componentDidMount = () => {
        this.setLogo();
    }

    setLogo = () => {
        const logo = localStorage.getItem('logoRsBase64');
        
        if (logo !== null){
            this.setState({
                base64: logo
            });
        }
    }

    onChange = (e) => {
        const file = e.target.files[0];
        getBase64(file).then(base64 => {
            localStorage["logoRsBase64"] = base64;
            this.setState({
                base64: base64
            });
        });
    }

    render() {
        return (
            <div className="clearfix">
                <input id="bannerImg" type="file" name="userfile" onChange={this.onChange} />
                <img alt="-" src={this.state.base64} id="tableBanner" />
            </div>
        );
    }
}

const getBase64 = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
        reader.readAsDataURL(file);
    });
}

SlogoForm.propTypes = {

};

export default SlogoForm;